import { render } from "./StatsBuilderColItem.vue?vue&type=template&id=ab0190bc"
import script from "./StatsBuilderColItem.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderColItem.vue?vue&type=script&lang=ts"

import "./StatsBuilderColItem.vue?vue&type=style&index=0&id=ab0190bc&lang=scss"
script.render = render

export default script